import React from "react";
import { useWhyForeverQuery } from "@framework/content/get-why-forever-card";
import { ImageCard } from "@framework/content/get-why-forever-card";
import WhyForeverCardsLoader from '@components/ui-old/loaders/why-forever-cards-loader';
import { AnimatedNoContent } from "@components/other/no-content";
import Container from "@components/ui-old/container";
const WhyForeverCards: React.FC = () => {
  const {
    data,
    isLoading,
    error
  } = useWhyForeverQuery();
  if (isLoading) {
    return <WhyForeverCardsLoader count={3} />;
  }
  if (error || !data) {
    return <Container>
        <AnimatedNoContent />
      </Container>;
  }
  const imageCards: ImageCard[] = data?.imageCards || [];
  return <section className="py-12" data-sentry-component="WhyForeverCards" data-sentry-source-file="why-forever-image-card.tsx">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {imageCards.map(card => <div key={card.id} className="flex flex-col justify-between bg-white dark:bg-neutral-900 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-neutral-200 dark:border-neutral-700" style={{
          minHeight: "500px"
        }}>
              <div className="p-4">
                <div className="relative">
                  <img src={card.image} alt={card.title} className="w-full h-auto object-contain" />
                  <h3 className="absolute bottom-0 left-2 right-2 text-center text-neutral-200 dark:text-neutral-100 text-lg border border-neutral-200 dark:border-neutral-700 rounded-lg shadow-md py-2 mb-4 bg-neutral-800/50">
                    {card.title}
                  </h3>
                </div>
                <div className="p-4">
                  <p className="text-neutral-700 dark:text-neutral-300 text-sm">{card.description}</p>
                </div>
              </div>
              <div className="p-4">
                <a href={card.linkUrl} target="_blank" rel="noopener noreferrer" className="block text-center bg-transparent border border-black dark:border-neutral-700 text-black dark:text-neutral-200 py-2 px-4 rounded-lg hover:bg-black dark:hover:bg-neutral-700 hover:text-white transition-colors duration-300">
                  {card.linkText}
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default WhyForeverCards;